// Import model
import { GenericFieldOptions } from '../models/GenericFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for GenericFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class GenericFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a GenericFieldOptions instance
   */
  static deserialize(json: string): GenericFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a GenericFieldOptions instance
   */
  static fromObject(obj: any): GenericFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to GenericFieldOptions');
    }


    const instance: GenericFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      f38A18B4: obj['_f38a18b4'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of GenericFieldOptions instances
   */
  static deserializeArray(json: string): GenericFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a GenericFieldOptions instance to a JSON string
   */
  static serialize(instance: GenericFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a GenericFieldOptions instance to a plain object
   */
  static toObject(instance: GenericFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      '_f38a18b4': instance.f38A18B4,
    };
  }

  /**
   * Serializes an array of GenericFieldOptions instances to a JSON string
   */
  static serializeArray(instances: GenericFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
